import Button from '../../../Button'

import {
  DELETE_DOCUMENT_TEMPLATE,
  DELETE_RECIPIENTS,
  EDIT_VARIABLES,
} from './EmailMissingVariablesModal.constants'

function isReportItemRecipient(reportItem, recipient) {
  return (
    (Boolean(reportItem.email) &&
      reportItem.email === (recipient.email || recipient.name)) ||
    (Boolean(reportItem.recipient) &&
      reportItem.recipient === recipient.profile?.id)
  )
}

function hasReportRecipient(report, recipient) {
  return report.some(reportItem => isReportItemRecipient(reportItem, recipient))
}

export function getMoreOptions({ report, t, template }) {
  return [
    ...(template?.id && report.some(r => r.external)
      ? [
          {
            label: t('Email.EditVariablesActionOptionsKey'),
            value: EDIT_VARIABLES,
          },
        ]
      : []),
    ...(report.some(r => r.recipient || r.email)
      ? [
          {
            label: t('Email.DeleteRecipientsActionOptionsKey'),
            value: DELETE_RECIPIENTS,
          },
        ]
      : []),
    ...(template?.id
      ? [
          {
            label: t('Email.DeleteTemplateActionOptionsKey'),
            value: DELETE_DOCUMENT_TEMPLATE,
          },
        ]
      : []),
  ]
}

export function filterRecipients(recipients, report) {
  return recipients.filter(recipient => !hasReportRecipient(report, recipient))
}

export function filterReportByRecipients(report, recipients) {
  return report.filter(reportItem =>
    recipients.some(recipient => isReportItemRecipient(reportItem, recipient))
  )
}

export function toMoreActionsFromOptions({
  actionClassName,
  moreOptions,
  onDeleteRecipients,
  onDeleteTemplate,
  onEditTemplate,
}) {
  return moreOptions.map(option => {
    switch (option.value) {
      case EDIT_VARIABLES:
        return {
          Component: Button.Flat,
          className: actionClassName,
          height: 40,
          key: EDIT_VARIABLES,
          text: option.label,
          onClick: onEditTemplate,
        }
      case DELETE_RECIPIENTS:
        return {
          Component: Button.Flat,
          className: actionClassName,
          height: 40,
          key: DELETE_RECIPIENTS,
          text: option.label,
          tooltip: option.label,
          onClick: onDeleteRecipients,
        }
      case DELETE_DOCUMENT_TEMPLATE:
        return {
          Component: Button.Flat,
          className: actionClassName,
          height: 40,
          key: DELETE_DOCUMENT_TEMPLATE,
          text: option.label,
          onClick: onDeleteTemplate,
        }
    }
  })
}
